import { InitiativeActions } from '../actions';
import { Initiative } from '../stores';
import Immutable from 'seamless-immutable';

const initialState = Immutable(Initiative);

export function initiative(store = initialState, action) {
	switch (action.type) {
		case InitiativeActions.CreateInitiativeAction.Request: {
			return store.merge({ isInitiativeCreating: true });
		}
		case InitiativeActions.CreateInitiativeAction.Success:
		case InitiativeActions.CreateInitiativeAction.Failure: {
			return store.merge({ isInitiativeCreating: false });
		}

		case InitiativeActions.CreateConsultationInitiativeAction.Request: {
			return store.set('isCreateConsultationInitiative', true);
		}
		case InitiativeActions.CreateConsultationInitiativeAction.Success:
		case InitiativeActions.CreateConsultationInitiativeAction.Failure: {
			return store.set('isCreateConsultationInitiative', false);
		}

		default: {
			return store;
		}
	}
}
